import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import {
  MentionedUser,
  RemoteMentionedUser,
  RemoteUser,
  RoleTypeName,
  User,
  UserClient,
} from './users.types';
import {DateTime} from 'luxon';

function toClientUsers(data: RemoteUser[]): User[] {
  return _map(data, (user: RemoteUser) => {
    const clients: UserClient[] = _map(user.userClients, (userClient) => ({
      ...userClient,
      expiresIn: !!userClient.expiration
        ? DateTime.fromISO(userClient.expiration).diffNow(['days', 'hours', 'minutes'])
        : null,
      connectedAdvertisers: userClient.connectedAdvertisers ?? [],
    }));
    const clientsByClientId = _keyBy(clients, 'id');

    return {
      ...user,
      userClients: clientsByClientId,
      relatedClients: clients,
      userRoles: _map((user?.roles?.toString() || RoleTypeName.None).split(','), (role) =>
        role.trim(),
      ) as RoleTypeName[],
    };
  });
}

function mentionedUsersToClientModel(users: RemoteMentionedUser[]): MentionedUser[] {
  return _map(users, (user) => ({
    id: user.userId,
    email: user.userEmail,
    firstName: user.userFirstName.trim(),
    lastName: user.userLastName.trim(),
  }));
}

export {toClientUsers, mentionedUsersToClientModel};
